import * as React from 'react'

import AppRoutes from '../../../routes'

import {PipelinePageEntryPoint} from './PipelinePage/PipelinePage.entryPoint'
import {PipelineRunPageEntryPoint} from './PipelineRunPage/PipelineRunPage.entryPoint'
import PipelinesPagesErrorBoundary from './PipelinesPages.errorBoundary'
import {isPipelinesEnabled} from './utils/featureToggles'

const PipelinesPages = React.lazy(
  () =>
    import(
      /* webpackChunkName: "PipelinesPages" */
      './PipelinesPages'
    ),
)

const IndexPage = React.lazy(
  () =>
    import(
      /* webpackChunkName: "PipelinesIndexPage" */
      './IndexPage/IndexPage'
    ),
)

const CreatePipelinePage = React.lazy(
  () =>
    import(
      /* webpackChunkName: "CreatePipelinePage" */
      './CreatePipelinePage/CreatePipelinePage'
    ),
)

const WelcomePage = React.lazy(
  () =>
    import(
      /* webpackChunkName: "WelcomePage" */
      './WelcomePage/WelcomePage'
    ),
)

const prefixLength = AppRoutes.PIPELINES.length - 1

export const pipelinesPagesRoute = isPipelinesEnabled
  ? {
      path: AppRoutes.PIPELINES,
      Component: PipelinesPages,
      ErrorBoundary: PipelinesPagesErrorBoundary,
      children: [
        {index: true, element: <IndexPage />},
        {path: AppRoutes.WELCOME_PIPELINES.slice(prefixLength), element: <WelcomePage />},
        {path: AppRoutes.CREATE_PIPELINE.slice(prefixLength), element: <CreatePipelinePage />},
        {path: AppRoutes.PIPELINE_RUN.slice(prefixLength), entryPoint: PipelineRunPageEntryPoint},
        {path: AppRoutes.PIPELINE.slice(prefixLength), entryPoint: PipelinePageEntryPoint},
      ],
    }
  : null
